import { defineStore } from 'pinia';

export const useMaintenanceModeStore = defineStore('maintenanceMode', {
    state: () => ({
        isMaintenanceMode: false,
        maintenanceMessage: 'The application is currently undergoing scheduled maintenance.'
    }),

    actions: {
        setMaintenanceMode(message = null) {
            this.isMaintenanceMode = true;
            if (message != null && typeof message === 'string') {
                this.maintenanceMessage = message;
            }
        },

        clearMaintenanceMode() {
            this.isMaintenanceMode = false;
            this.maintenanceMessage = 'The application is currently undergoing scheduled maintenance.';
        }
    }
});
